<template>
  <div class="login">
    <div class="login-logo">
      <a href="/">
        <img src="../assets/logo4.png"/>
      </a>
    </div>
    <div class="container">
      <div class="content-wrapper">
        <h4 class="content-titel">忘记密码</h4>
        <el-form :model="forgetPswForm" ref="forgetPswForm" :rules="rules" :show-message=false>
          <div class="list-group">
            <el-form-item class="list-group-item" prop="domain">
              <el-input
                type="text"
                required="required"
                v-model="forgetPswForm.domain"
                placeholder="团队代码"
                class="form-control"
              >
              </el-input>
            </el-form-item>
            <el-form-item class="list-group-item" prop="account">
              <el-input
                type="email"
                required="required"
                v-model="forgetPswForm.account"
                placeholder="邮箱"
                class="form-control"
              >
              </el-input>
            </el-form-item>
            <!--<div class="list-group-item forget-last-item">-->
            <el-form-item prop="captcha">
              <el-col :span="16">
                <el-input
                  required="required"
                  v-model="forgetPswForm.captcha"
                  placeholder="验证码"
                  class="form-control"
                  @keyup.enter="onKeyup()"
                >
                </el-input>
              </el-col>
              <el-col :span="8" class="send-code">
                <img :src="captchaSrc" alt="" style="width: 100%;height: 32px;margin-top:2px" @click="refresh()">
              </el-col>
            </el-form-item>
          </div>
          <el-form-item>
            <el-button @click.stop.prevent="resetPasswordMail()" :disabled="!canSubmit" class="submit-btn">
              <span v-if="!loading"><translate>Submit</translate></span>
              <span v-if="loading">
              <translate>Submiting</translate>
              <i class="el-icon-loading"></i>
            </span>
            </el-button>
          </el-form-item>

          <div class=" capitalize clearfix">
            <router-link to="login" class="pull-left login-link">
              <translate>Login</translate>
            </router-link>
            <!--a.pull-right(ui-sref="signup" translate) sign up an company-->
          </div>
        </el-form>
      </div>
    </div>
    <div class="copyright clearfix">
      <div>Copyright 2013-2022 上海驻云信息科技有限公司</div>
      <div>Powered by
        <a href="https://cloudcare.cn/" target="_blank" class="text-primary new-block">cloudcare.cn</a>
      </div>
    </div>
  </div>
</template>
<script>
  import STORE_CONST from '../store/consts'
  import { baseUrl } from '../config'
  export default {
    name: 'forgetPsw',
    data () {
      return {
        loading: false,
        forgetPswForm: {
          domain: '',
          account: '',
          captcha: ''
        },
        canSubmit: false,
        captchaSrc: baseUrl.apiUrl + '/auth/captcha' + '?' + new Date().getTime(),
        rules: {
          domain: [
            {required: true, trigger: 'blur'}
          ],
          account: [
            {required: true, trigger: 'blur'},
            {type: 'email', trigger: 'change'}
          ],
          captcha: [
            {required: true, trigger: 'blur'}
          ]
        }
      }
    },
    methods: {
      onKeyup () {
        if (this.canSubmit) {
          this.resetPasswordMail()
        }
      },
      resetPasswordMail (m) {
        this.loading = true
        this.$store.dispatch(STORE_CONST.ACCOUNT.FORGRTPASSWORD, this.forgetPswForm).then(res => {
          this.loading = false
          this.$notify({
            message: this.$gettext('Submitted successfully! Please click the link in the message to set the password. '),
            type: 'success'
          })
        }, err => {
          console.log(err)
          this.loading = false
          this.refresh()
          this.forgetPswForm.captcha = ''
        })
      },
      refresh () {
        this.captchaSrc = baseUrl.apiUrl + '/auth/captcha' + '?' + new Date().getTime()
      },
      resetFields () {
        this.$refs['forgetPswForm'].resetFields()
      }
    },
    watch: {
      'forgetPswForm': {
        handler: function (newVal, oldVal) {
          const that = this
          if (this.$refs['forgetPswForm']) {
            this.$refs['forgetPswForm'].validate(function (valid) {
              that.canSubmit = valid
            })
          }
        },
        deep: true
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" rel="stylesheet/scss" scoped>
  @import '../assets/css/variable';
.login {
  .login-link {
    color: $textColor;
    text-decoration: none;
    &:hover {
      color: $mainColor;
    }
  }
  .forget-last-item {
    .el-form-item {
      margin-bottom: 0;
    }
  }
  .el-form {
    width: 300px;
    margin: 30px auto;
    .el-form-item {
      &.is-error {
        .el-input {
          .el-input__inner {
            border-color: #bfcbd9 !important;
          }
        }
      }

    }
    .list-group-item {
      /*padding:0px 15px;*/
      .el-form-item__content {
        width: 100%;
      }
    }
    .submit-btn {
      /*font-size: 16px;*/
      border-radius: 0;
      width: 100%;
    }
  }
  .send-code {
    .el-button {
      border-left: 0;
      padding: 8px 15px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// forgot-password.vue?5800314f